import type React from "react";
import type {MainComponentBaseProps} from "../RootTypes.ts";
import {HeaderAlert} from "../alerts/HeaderAlert.tsx";
import {DevopsMenu} from "../devops/DevopsMenu.tsx";
import {SelectDataset} from "./SelectDataset.tsx";
import {SingleDropdownMenu} from "~/pages/default-menus/SingleDropdownMenu.tsx";
import {useStores} from "~/stores/index.tsx";

export const MainHeader: React.FC<MainComponentBaseProps> = () => {
    const {p} = useStores();

    return <>
        <HeaderAlert/>
        <SelectDataset/>
        <div style={{flexGrow: 1}}/>
        {p.p.branding === 'NExO' && <img src="/logo/NExO_logo_v4_02_h60.png" height={24} alt="NExO" className="nexo-logo"/>}
        <SingleDropdownMenu/>
        <DevopsMenu/>
    </>
}

